import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const MoreTime = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon width={24} height={24} {...other}>
			<path
				d="M12,2 C17.5228475,2 22,6.4557218 22,11.9521332 C22,17.4485446 17.5228475,21.9042664 12,21.9042664 C9.84161419,21.9042664 7.8429402,21.2237319 6.20880009,20.0665046 L6.024,19.925 L3.93933983,22 L3.23223305,15.6665012 L9.59619408,16.3702233 L7.49721259,18.4593125 C7.54704543,18.5159333 7.59738759,18.5741477 7.64823906,18.6339558 C8.90076497,19.4435735 10.3952001,19.9138397 12,19.9138397 C16.418278,19.9138397 20,16.3492623 20,11.9521332 C20,7.55500408 16.418278,3.99042664 12,3.99042664 C7.581722,3.99042664 4,7.55500408 4,11.9521332 C4,13.1145405 2,13.3935234 2,11.9521332 C2,6.4557218 6.4771525,2 12,2 Z M11.2211678,5.98101945 C11.8956002,5.98101945 12.3333333,6.44145593 12.3333333,7.19721074 L12.3333333,12.0627883 L15.8037572,13.8719616 C16.4707871,14.2196922 16.7419357,15.0337051 16.4166667,15.7119716 C16.1286602,16.3125363 15.4083309,16.5659149 14.8077661,16.2779084 C14.7672128,16.2584607 14.7277791,16.2367597 14.6896499,16.2129071 L10,13.2791828 L10,7.19721074 C10,6.44145593 10.5467355,5.98101945 11.2211678,5.98101945 Z"
				id="moreTime"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

MoreTime.propTypes = {
	color: PropTypes.string,
};

export default MoreTime;
